import { uuidv4 } from '../../_Global/js/utils';

document.addEventListener('DOMContentLoaded', () => {
  const players = document.querySelectorAll('.audio-embed');

  function init(player) {
    const audio = player.querySelector('.audio-player');
    const playPauseBtn = player.querySelector('.playPauseBtn');
    const progressBar = player.querySelector('.progressBar');
    const volumeControl = player.querySelector('.volumeControl');
    const currentTimeElem = player.querySelector('.currentTime');
    const durationElem = player.querySelector('.duration');
    const downloadBtn = player.querySelector('.downloadBtn');
    const optionsElem = player.querySelector('.audio-embed__options');
    const transcriptBtn = player.querySelector('.transcriptBtn');
    const transcriptElem = player.querySelector('.audio-embed__transcript');

    if(audio.duration){
      player.querySelectorAll('button, input').forEach(el => {el.removeAttribute('disabled')});

      // Play/Pause button functionality
      if (playPauseBtn) {
        playPauseBtn.addEventListener('click', () => {
          if (audio.paused) {
            audio.play();
            playPauseBtn.querySelector('span').textContent = 'Pause';
            playPauseBtn.querySelector('use').setAttribute('xlink:href', '#pause');
          } else {
            audio.pause();
            playPauseBtn.querySelector('span').textContent = 'Play';
            playPauseBtn.querySelector('use').setAttribute('xlink:href', '#play');
          }
        });

        audio.addEventListener('ended', () => {
          playPauseBtn.querySelector('span').textContent = 'Play';
          playPauseBtn.querySelector('use').setAttribute('xlink:href', '#play');
        });
      }

      // Update progress bar and current time
      if (progressBar && currentTimeElem && durationElem) {
        durationElem.textContent = formatTime(audio.duration);

        audio.addEventListener('timeupdate', () => {
          const progress = (audio.currentTime / audio.duration) * 100;
          progressBar.value = progress;
          currentTimeElem.textContent = formatTime(audio.currentTime);
          durationElem.textContent = formatTime(audio.duration);
          updateProgress(progressBar);
        });

        // Seek functionality
        progressBar.addEventListener('input', () => {
          const newTime = (progressBar.value / 100) * audio.duration;
          audio.currentTime = newTime;
          updateProgress(progressBar);
        });
      }

      // Volume control functionality
      if (volumeControl) {
        updateVolume(volumeControl);

        volumeControl.addEventListener('input', () => {
          audio.volume = volumeControl.value;
          updateVolume(volumeControl);
        });
      }

      // Download button functionality
      if (downloadBtn) {
        downloadBtn.addEventListener('click', () => {
          if (audio.querySelector('source').src) {
            const link = document.createElement('a');
            link.href = audio.querySelector('source').src;
            link.setAttribute('target', '_blank');
            link.download = 'audio-file.mp3';
            link.click();
          }
        });
      }
    }

    // Toggle transcript visibility
    if (transcriptBtn && transcriptElem) {
      const accordionId = uuidv4();
      const buttonId = `acc-${accordionId}-button-0`;
      const contentId = `acc-${accordionId}-section-0`;

      // Set the button ID
      transcriptBtn.setAttribute('id', buttonId);

      // Link to the content
      transcriptBtn.setAttribute('aria-controls', contentId);

      // Set the content ID
      transcriptElem.setAttribute('id', contentId);

      // Link to the button
      transcriptElem.setAttribute('aria-labelledby', buttonId);

      transcriptBtn.addEventListener('click', (evt) => {
        const accordionButton = evt.currentTarget;
        const accordionActiveClass = 'accordion--active';
        const accordionIconAnimationClass = 'icon__expand--active';
        const isExpanded = accordionButton.classList.contains(accordionActiveClass);

        evt.preventDefault();

        if (isExpanded) {
          // Close the accordion
          accordionButton.classList.remove(accordionActiveClass, accordionIconAnimationClass);
          accordionButton.setAttribute('aria-expanded', 'false');
          optionsElem.classList.remove('accordion--active');
          transcriptBtn.querySelector('span').textContent = 'Show Transcript';
        } else {
          // Open the accordion
          accordionButton.classList.add(accordionActiveClass, accordionIconAnimationClass);
          accordionButton.setAttribute('aria-expanded', 'true');
          optionsElem.classList.add('accordion--active');
          transcriptBtn.querySelector('span').textContent = 'Hide Transcript';
        }
      });
    }
  }

  function updateProgress(progressBar) {
    const value = (progressBar.value - progressBar.min) / (progressBar.max - progressBar.min) * 100;
    progressBar.parentElement.style.setProperty('--slider-progress', `${value}%`);
  }

  function updateVolume(volumeBar) {
    const value = (volumeBar.value - volumeBar.min) / (volumeBar.max - volumeBar.min) * 100;
    volumeBar.parentElement.style.setProperty('--volume-progress', `${value}%`);
  }

  // Format time function
  function formatTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  }

  players.forEach(player => {
    const audio = player.querySelector('.audio-player');
    const audioSrc = player.querySelector('.audio-player source');
    const errorElement = player.querySelector('[data-role="error-message"]');

    // Note: This only seems to work on Chrome.
    // Even then, I also suspect it doesn't always catch the error because we preload the metadata
    audioSrc.addEventListener('error', () => {
      errorElement.classList.add('show-message');
    });

    if(audio.readyState > 0) {
      init(player);
    } else {
      audio.addEventListener('loadedmetadata', () => {
        init(player);
      });
    }
  });
});


